export default function jsonParsedData(data) {
    return Object.keys(data).reduce((obj, key) => {
        if (data[key] !== '') {
            obj[key] = typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key];
        }
        return obj;
    }, {});
}